import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth, isTokenExpired } from '../../hooks/useAuth';

interface ProtectedRouteProps {
  children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  // Proactive check: if the token exists but is expired, clear it immediately
  // and redirect — don't wait for a GraphQL request to surface the 401.
  if (isTokenExpired()) {
    localStorage.removeItem('bms_access_token');
    localStorage.removeItem('bms_refresh_token');
    localStorage.removeItem('bms_current_user');
    return <Navigate to="/login" replace />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;
